import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, CardBody, Card, CardHeader, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getWarehouseByEstablishment, getWarehouseItemList, synchronizeWarehouseItems, getWarehouseItemListQuery, getWarehouseItemTransferList, getWarehouseItemTransferListQuery } from '../../../../slices/thunks';
import { Link } from 'react-router-dom';
// import AddEditItemModal from './Add_Edit/AddEditItem';
// import DeleteItemModal from './Delete/DeleteItem';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import PersonalProtectiveEquipmentTransferModal from '../../../PersonalProtectiveEquipment/Add_Edit/PersonalProtectiveEquipmentTransfer';
import { useUser } from '../../../../Components/Hooks/useUserHooks';
import ChargeDocumentModal from './Modals/ChargeDocumentModal';
import TransferFilesModal from './Modals/TransferFilesModal';
// import ReceptionItemModal from './Modals/ReceptionItemModal';

const ItemList = ({ establishment_id }) => {
    const dispatch = useDispatch();
    const { user } = useUser();

    const selectorItems = createSelector(
        state => state.WarehouseItemTransfers,
        data => ({
            dataList: data.warehouseItemList,
            isLoadingList: data.isLoadingList,
            isItemSuccess: data.isItemSuccess,
            error: data.error,
            isAdding: data.isAdding,
            isAdded: data.isAdded,
            isAddError: data.isAddError,
            isUpdating: data.isUpdating,
            isUpdated: data.isUpdated,
            isUpdateError: data.isUpdateError,
            isDeleting: data.isDeleting,
            isDeleted: data.isDeleted,
            isDeleteError: data.isDeleteError,
        })
    );

    const { dataList, isLoadingList } = useSelector(selectorItems);

    const selectorWarehouse = createSelector(
        state => state.Warehouses,
        data => ({
            itemWarehouse: data.itemWarehouse,
            itemWarehouseDetail: data.itemWarehouseDetail,
            isLoadingWarehouseList: data.isLoadingWarehouseList,
        })
    );

    const { itemWarehouse, itemWarehouseDetail, isLoadingWarehouseList } = useSelector(selectorWarehouse);


    useEffect(() => {
        const fetchData = async () => {
            const warehouse = await dispatch(getWarehouseByEstablishment(establishment_id));
            dispatch(getWarehouseItemTransferList({
                establishment_id: establishment_id,
                warehouse_usage_type_code: 'EPP',
                all: true
            }));
        };
        fetchData();
    }, [establishment_id]);


    const [dataItem, setDataItem] = useState({});
    const [isEdit, setIsEdit] = useState(false);

    // Delete Item
    const [modal, setModal] = useState(false);
    const [modalTransfer, setModalTransfer] = useState(false);
    const [modalTransferFiles, setModalTransferFiles] = useState(false);
    // const [modalReception, setModalReception] = useState(false);
    //Tab
    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    // Update Data
	const handleClickEdit = data => {
		setDataItem(data);
		handleToggleModal();
	};

    function handleToggleModalTransfer() {
        setModalTransfer(!modalTransfer);
        toggleTab('1');
        // validation.resetForm();
    }

    function handleToggleModal() {
		setModal(!modal);
	}

    function handleToggleModalTransferFiles(data) {
        setDataItem(data);
		setModalTransferFiles(
			!modalTransferFiles
		);
	}

    useEffect(() => {
        dispatch(getWarehouseItemTransferList({ warehouse: establishment_id }));
    }, [itemWarehouseDetail]);

    const columns = useMemo(
        () => [
            {
                header: 'Acciones',
                enableSorting: false,
                enableColumnFilter: false,
                enableGlobalFilter: false,
                enableColumnActions: false,
                accessorKey: 'categories',
                columnDefType: 'display',
                width: '3%',
                Cell: cellProps => {
                    const transfer = cellProps.row.original;
                    console.log('transfer', transfer)

                    return (
                        <React.Fragment>
                            <div className='d-flex'>
                                <div className='flex-shrink-0'>
                                    <ul className='list-inline mb-0'>
                                        {(
                                            <li className='list-inline-item'>
                                                <Link
                                                    to='#'
                                                    onClick={() => {
                                                        handleToggleModalTransferFiles(
                                                            transfer
                                                        );
                                                    }}
                                                    title='Ver Documentos'
                                                >
                                                    <i className='ri-file-search-line align-bottom me-2 text-muted'></i>
                                                </Link>
                                            </li>
                                        )}
                                        <li className={`list-inline-item ${transfer.warehouse_transfer?.document_id == null ? '' : 'disabled'}`}>
                                            <Link
                                                to='#'
                                                onClick={() => {
                                                    if (!cellProps.row.original.warehouse_transfer.document_id) {
                                                        const transferData = cellProps.row.original;
                                                        setIsEdit(true);
                                                        handleClickEdit(transferData);
                                                    }
                                                }}
                                                aria-disabled={(cellProps.row.original.warehouse_transfer.document_id ? true : false)}
                                                title='Cargar Documento Transferencia'
                                            >
                                                <i className='ri-upload-2-line align-bottom me-2 text-muted'></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                },
            },
            { header: 'Nombre', accessorKey: 'warehouse_item.name', size: 'auto' },
            { header: 'Código', accessorKey: 'warehouse_item.code_sap', size: 'auto' },
            { header: 'Cantidad', accessorKey: 'quantity', size: 'auto', summary: true, type: 'separator' },
            { header: 'Bodega de Origen', accessorKey: 'warehouse_origin.name', size: 'auto' },
            { header: 'Bodega de Destino', accessorKey: 'warehouse_destination.name', size: 'auto' },
            {
				header: 'Recibido', accessorKey: 'received',  size: 'auto', dataType: 'boolean',
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='privacy_policy'
							name='privacy_policy'
							disabled
							checked={row.original.received}
						/>
					);
				},
			},
        ],
        [handleClickEdit]
    );

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <Card>
                        {/* <CardHeader className='border-0 pb-0'>
                            <div className='d-flex align-items-end justify-content-end'>
                                <div className='flex-shrink-0'>
                                    <div className='d-flex flex-wrap gap-2'>
                                        /* <button className='btn btn-label btn-primary' disabled={isLoadingWarehouseList} onClick={() => { synchronize(); }}>
                                            {isLoadingWarehouseList ? (<i className="label-icon"><Spinner size='sm' /></i>) : <i className="icon-refresh-cw label-icon"></i>} Sincronizar con SAP
                                        </button>

                                        <button className='btn btn-label btn-primary' onClick={() => { setIsEdit(false); setDataItem({}); handleToggleModal(); }}>
                                            <i className={`${Icons.plus} label-icon`}></i>{' '}
                                            Agregar Item
                                        </button>

                                        <button className='btn btn-label btn-primary' onClick={() => { handleToggleModalTransfer(); }}>
                                            <i className={`${Icons.plus} label-icon`}></i>{' '}
                                            Transferir EPP a Bodega
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </CardHeader> */}
                        <CardBody>
                            <ODataGrid
                                columns={columns}
                                data={dataList || []}
                                isLoadingData={isLoadingList}
								nameFile={'transferencias'}
                                customToolbarActions={[
									{
										label: 'Transferir',
										icon: Icons.plus,
										className: 'gap-1',
										onClick: () => { handleToggleModalTransfer(); },
										title: 'Transferir EPP a Bodega',
									},
									
								]}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <PersonalProtectiveEquipmentTransferModal
                dataPersonalProtectiveEquipment={{}}
				isEdit={isEdit}
				isOpen={modalTransfer}
				handleToggleModal={handleToggleModalTransfer}
				activeTab={activeTab}
				toggleTab={toggleTab}
                establishmentId={establishment_id}
            />
            <ChargeDocumentModal
                data={dataItem}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
            />
            <TransferFilesModal
				dataTransfer={dataItem}
				isOpen={modalTransferFiles}
				handleToggleModal={
					handleToggleModalTransferFiles
				}
			/>
        </React.Fragment>
    );
};

export default ItemList;
